import { blrfOperations } from 'app/state/ducks/blrf';

const { clear } = blrfOperations;

const search = ( key, data ) => ( dispatch ) => {

    return dispatch ( blrfOperations.search( {
        endpoint: 'coin/user/search',
        key, 
        data
    }) );

};

export {
    search
};
